export function normalizePublicUsername(value = '') {
  return String(value || '').trim();
}

export function validatePublicUsername(value = '') {
  const username = normalizePublicUsername(value);

  if (!username) {
    return 'Choose a public username.';
  }

  if (username.toLowerCase() === 'frolikadmin') {
    return 'That username is reserved.';
  }

  if (username.length < 3) {
    return 'Username must be at least 3 characters.';
  }

  if (username.length > 24) {
    return 'Username must be 24 characters or fewer.';
  }

  if (!/^[a-zA-Z0-9._-]+$/.test(username)) {
    return 'Use letters, numbers, dots, underscores, or dashes only. Never use your real name.';
  }

  return '';
}
